import {
  baseFields,
  couponFields,
  FormModel,
  onlineFlags,
  PosFields,
  requiredProductFields,
  templateConstraintFields,
} from '../index'

export function getFormModelKeys(): (keyof FormModel)[] {
  return [
    ...baseFields,
    'discount',
    ...onlineFlags,
    ...requiredProductFields,
    'instoreRedemptionType',
    'availableCustomerSupport',
    'images',
    ...couponFields,
    'posFields',
    'productIds',
    ...templateConstraintFields,
  ]
}

export function getPosFieldKeys(): (keyof PosFields)[] {
  return [
    'instoreRedemptionType',
    'productIds',
    'instoreRequiredProductIds',
    'onlineRequiredProductIds',
    ...couponFields,
  ]
}
